function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import map from 'lodash/map';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import OrganizationMemberships from './OrganizationMemberships';
import styles from './ClinicMemberships.pcss';
var _React_PureComponent;
class ClinicMemberships extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        if (!prevProps.isClientInitialized && this.props.isClientInitialized) {
            this.onFetchOrganizationAndClinicMemberships();
        }
    }
    onFetchOrganizationAndClinicMemberships() {
        if (process.env.BROWSER && !this.props.isClientInitialized) {
            return;
        }
        const organizationUID = get(this.props.activeClinicMembership, 'clinic.organizationUID');
        const clinicId = get(this.props.activeClinicMembership, 'clinicId');
        this.props.onFetchOrganizationMemberships(organizationUID);
        this.props.onFetchClinicMemberships(clinicId);
    }
    renderManageOrganizationBtn() {
        const organizationUID = get(this.props.activeClinicMembership, 'clinic.organizationUID');
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons.manageOrganization,
            className: "btn--filled",
            onClick: ()=>this.props.onManageOrganization(organizationUID)
        });
    }
    renderHcpAvatar(profile) {
        if (!profile) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: profile.avatar,
            name: [
                profile.firstName,
                profile.lastName
            ],
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
    }
    renderLastSuccessfulLogin(clinicMembership) {
        const isClinicAdmin = get(this.props.activeClinicMembership, 'isAdmin');
        if (!isClinicAdmin) {
            return null;
        }
        const lastSuccessfulLoginTimestamp = get(clinicMembership, 'profile.lastSuccessfulLoginTimestamp');
        return /*#__PURE__*/ _jsx("td", {
            children: moment.unix(lastSuccessfulLoginTimestamp).local().format('L LT')
        });
    }
    renderLastFailedLogin(clinicMembership) {
        const isClinicAdmin = get(this.props.activeClinicMembership, 'isAdmin');
        if (!isClinicAdmin) {
            return null;
        }
        const lastFailedLoginAttemptTimestamp = get(clinicMembership, 'profile.lastFailedLoginAttemptTimestamp');
        return /*#__PURE__*/ _jsx("td", {
            children: lastFailedLoginAttemptTimestamp ? moment.unix(lastFailedLoginAttemptTimestamp).local().format('L LT') : null
        });
    }
    renderMembership(clinicMembership) {
        const { clinicHcpMembershipId, profile, hcpBusinessEmail, isAdmin } = clinicMembership;
        return /*#__PURE__*/ _jsxs("tr", {
            className: "section__table__row",
            children: [
                /*#__PURE__*/ _jsx("td", {
                    className: "cell--avatar",
                    children: this.renderHcpAvatar(profile)
                }),
                /*#__PURE__*/ _jsxs("td", {
                    className: "w-25",
                    "data-hj-suppress": true,
                    children: [
                        profile.firstName,
                        " ",
                        profile.lastName
                    ]
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: hcpBusinessEmail
                }),
                this.renderLastSuccessfulLogin(clinicMembership),
                this.renderLastFailedLogin(clinicMembership),
                /*#__PURE__*/ _jsx("td", {
                    children: isAdmin && 'Admin'
                })
            ]
        }, clinicHcpMembershipId);
    }
    renderTableBody() {
        return /*#__PURE__*/ _jsx("tbody", {
            className: "section__table__body",
            children: map(this.props.clinicMemberships, (clinicMembership)=>this.renderMembership(clinicMembership))
        });
    }
    renderLastSuccessfulLoginHead() {
        const isClinicAdmin = get(this.props.activeClinicMembership, 'isAdmin');
        if (!isClinicAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("th", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lastLogin))
        });
    }
    renderLastFailedLoginHead() {
        const isClinicAdmin = get(this.props.activeClinicMembership, 'isAdmin');
        if (!isClinicAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsx("th", {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lastLoginFailed))
        });
    }
    renderTableHead() {
        return /*#__PURE__*/ _jsx("thead", {
            className: "section__table__head",
            children: /*#__PURE__*/ _jsxs("tr", {
                children: [
                    /*#__PURE__*/ _jsx("th", {
                        colSpan: 2,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.hcp))
                    }),
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.email))
                    }),
                    this.renderLastSuccessfulLoginHead(),
                    this.renderLastFailedLoginHead(),
                    /*#__PURE__*/ _jsx("th", {
                        "aria-label": "Admin"
                    })
                ]
            })
        });
    }
    renderMemberships() {
        return /*#__PURE__*/ _jsx("div", {
            className: "section__table-container",
            children: /*#__PURE__*/ _jsxs("table", {
                className: "section__table",
                children: [
                    this.renderTableHead(),
                    this.renderTableBody()
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("h2", {
                    className: "section__header d-flex align-items-end justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "d-block",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.clinicHcps))
                        }),
                        this.renderManageOrganizationBtn()
                    ]
                }),
                this.renderMemberships(),
                /*#__PURE__*/ _jsx(OrganizationMemberships, {
                    status: "Pending",
                    headerMessage: messages.headers.clinicHcpPending
                }),
                /*#__PURE__*/ _jsx(OrganizationMemberships, {
                    status: "Invitation",
                    headerMessage: messages.headers.clinicHcpInvitations
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onFetchOrganizationAndClinicMemberships();
    }
}
_define_property(ClinicMemberships, "propTypes", {
    // Explicit props
    activeClinicMembership: Account.shapes.clinicMembership.isRequired,
    clinicMemberships: PropTypes.arrayOf(shapes.clinicMembership),
    // Implicit props
    isClientInitialized: PropTypes.bool,
    // Implicit actions
    onFetchClinicMemberships: PropTypes.func,
    onFetchOrganizationMemberships: PropTypes.func,
    onManageOrganization: PropTypes.func
});
const mapStateToProps = (state)=>({
        clinicMemberships: selectors.clinicMemberships(state),
        isClientInitialized: App.selectors.isClientInitialized(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchOrganizationMemberships: (organizationUID)=>dispatch(actions.fetchOrganizationMemberships(organizationUID, [
                'Invitation',
                'Pending'
            ])),
        onFetchClinicMemberships: (clinicId)=>dispatch(actions.fetchClinicMemberships(clinicId)),
        onManageOrganization: (organizationUID)=>dispatch(actions.manageOrganization(organizationUID))
    });
const ConnectedClinicMemberships = connect(mapStateToProps, mapDispatchToProps)(ClinicMemberships);
export default withStyles(styles)(ConnectedClinicMemberships);
